module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"dap":"DAP","dap_descrip":"Declaración ambiental","guardar":"Guardar","cerrar":"Cerrar","restaurar_todo":"Restaurar todo"}}')
  delete Component.options._Ctor
}
